import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useForm } from 'react-hook-form';
import { pnrRegex } from 'utils/validators';
import { ConfirmButton, CancelButton } from 'components/ui/Button';

import {
  PointsInput,
  MandatoryFieldLabel,
  ActionsList,
  Error,
  PointsFormField,
  AddBookingFormWrapper,
  ErrorContainer
} from '../../ClubEurostarMember.styles';

const AddBookingForm = ({ onSubmit, onCancel, loading, error }) => {
  const {
    register,
    handleSubmit,
    formState: { isValid, errors }
  } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {
      pnr: '',
      lastName: ''
    }
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)} data-cy="add-booking-form" data-testid="add-booking-form">
      <AddBookingFormWrapper>
        <PointsFormField>
          <MandatoryFieldLabel htmlFor="pnr">
            <FormattedMessage id="clubEurostar.associatedPNR" />
          </MandatoryFieldLabel>
          <div>
            <PointsInput {...register('pnr', { required: true, pattern: pnrRegex })} type="text" id="pnr" />
          </div>
          {errors.pnr && (
            <Error data-cy="error">
              <FormattedMessage id="clubEurostar.pnrValidationMessage" />
            </Error>
          )}
        </PointsFormField>
        <PointsFormField>
          <MandatoryFieldLabel htmlFor="lastName">
            <FormattedMessage id={'clubEurostar.addBooking.lastName'} />
          </MandatoryFieldLabel>
          <div>
            <PointsInput
              {...register('lastName', {
                required: true,
                pattern: /^([\D]|-){2,34}$/
              })}
              type="text"
              id="latName"
            />{' '}
          </div>
          {errors.lastName && (
            <Error data-cy="error">
              <FormattedMessage id="clubEurostar.lastNameValidationMessage" />
            </Error>
          )}
        </PointsFormField>
      </AddBookingFormWrapper>
      {error && (
        <ErrorContainer>
          <Error>
            <FormattedMessage id="clubEurostar.addBooking.errorMessage" />
          </Error>
        </ErrorContainer>
      )}
      <ActionsList>
        <CancelButton type="button" data-cy="add-booking-cancel-button" data-testid="add-booking-cancel-button" onClick={onCancel}>
          <FormattedMessage id="clubEurostar.cancel" />
        </CancelButton>
        <ConfirmButton
          type="submit"
          data-cy="add-booking-confirm-button"
          data-testid="add-booking-confirm-button"
          disabled={!isValid || loading}
          loading={loading}
        >
          <FormattedMessage id="clubEurostar.confirm" />
        </ConfirmButton>
      </ActionsList>
    </form>
  );
};

AddBookingForm.propTypes = {
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  loading: PropTypes.bool,
  error: PropTypes.string
};

export default AddBookingForm;
